var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.getComponent(_vm.test.status),{tag:"component",attrs:{"is-owner":_vm.isOwner,"paid-attempts":_vm.paidAttempts,"test":_vm.test,"has-report":_vm.hasReport},on:{"sendTest":function($event){return _vm.$emit('sendTest', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }